
import React, { useState, useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import InitialAdminSetup from './InitialAdminSetup';
import EmployeeForm from './EmployeeForm';

interface AddEmployeeDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onEmployeeAdded: () => void;
}

const AddEmployeeDialog: React.FC<AddEmployeeDialogProps> = ({
  isOpen,
  onOpenChange,
  onEmployeeAdded,
}) => {
  const [needsInitialAdmin, setNeedsInitialAdmin] = useState(false);

  useEffect(() => {
    // Check if we need to create the initial admin user on first load
    const checkInitialAdminSetup = async () => {
      // Check if we have the specific admin email in the URL
      const urlParams = new URLSearchParams(window.location.search);
      const setupAdmin = urlParams.get('setupAdmin');
      
      if (setupAdmin === 'true') {
        setNeedsInitialAdmin(true);
        
        // Clear the URL parameter
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    };
    
    checkInitialAdminSetup();
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        {needsInitialAdmin ? (
          <>
            <DialogHeader>
              <DialogTitle>Setting Up Admin Account</DialogTitle>
              <DialogDescription>
                Please wait while we set up your admin account...
              </DialogDescription>
            </DialogHeader>
            <InitialAdminSetup 
              onSetupComplete={onEmployeeAdded} 
              onOpenChange={onOpenChange}
            />
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>Add New Employee</DialogTitle>
              <DialogDescription>
                Add a new employee to the IT MGMT Solutions portal. They will receive a verification email.
              </DialogDescription>
            </DialogHeader>
            
            <EmployeeForm onEmployeeAdded={onEmployeeAdded} />
            
            <DialogFooter>
              <DialogClose asChild>
                <Button type="button" variant="outline">
                  Cancel
                </Button>
              </DialogClose>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AddEmployeeDialog;
